import { computed, defineComponent, reactive, ref, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { useModal, useUser } from '~/composables';
import { pluralize } from '~/utils';
import { useDuck } from '~/services';
const duck = useDuck();
export default defineComponent({
    name: 'PricingPlan',
    props: {
        isInset: {
            default: false,
            type: Boolean,
        },
        plan: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const modal = useModal();
        const user = useUser();
        const activeTab = ref(props.plan.initialTab || 0);
        const currentTab = computed(() => props.plan.tabs[activeTab.value]);
        const currentPromo = computed(() => {
            return currentTab.value.promo;
        });
        const shouldRecurrent = ref(true);
        const tabs = reactive({
            change(tab) {
                const index = props.plan.tabs.findIndex((v) => v.value === tab.value);
                if (index !== -1) {
                    activeTab.value = index;
                }
            },
            currentTab: currentTab.value,
            tabs: computed(() => {
                return props.plan.tabs.map((tab) => {
                    tab.theme = 'white';
                    if (tab.value === currentTab.value?.value) {
                        tab.theme = 'light';
                    }
                    return tab;
                });
            }),
        });
        const comment = computed(() => {
            if (currentTab.value?.comment) {
                return currentTab.value?.comment;
            }
            if (currentPromo.value) {
                const { recurrentPrice } = currentPromo.value;
                return `Первый месяц, далее ${recurrentPrice} р. в месяц`;
            }
            const { months = 1, price } = currentTab?.value;
            if (months > 1 && price) {
                return `${Number(price / months).toFixed(2)} р. месяц`;
            }
            return 'В месяц';
        });
        const paymentModal = computed(() => {
            const { months = 1, price } = currentTab?.value;
            const { title: plan } = props.plan;
            const pluralizedMonths = pluralize(months, 'месяц', 'месяца', 'месяцев', true);
            return {
                price,
                subtitle: `Оформление подписки Forbes по тарифу ${plan} на ${pluralizedMonths}`,
                title: 'Оплата',
            };
        });
        const taskBuyPlan = useTask(function* () {
            const pkg = props.plan.pkg;
            if (!pkg) {
                return;
            }
            console.log(pkg);
            try {
                const { data } = yield duck.invoices.postInvoices({
                    email: user.info.info.email,
                    packageId: Number(pkg.id),
                    ...(currentPromo.value
                        ? { promoactionId: Number(currentPromo.value.id) }
                        : { priceId: Number(pkg.prices?.[activeTab.value].id) }),
                });
                return data;
            }
            catch (error) { }
        });
        function openFeaturesModal() {
            const { features, subtitle, title } = props.plan;
            modal.open('pricingFeatures', {
                componentAttrs: {
                    features,
                    paymentModal: paymentModal.value,
                    subtitle,
                    title,
                },
            });
        }
        async function openPaymentModal() {
            if (!window.cp) {
                return;
            }
            if (!user.isAuthorized) {
                modal.key = 'signIn';
                modal.modals.signIn.componentAttrs = {
                    handler: openPaymentModal,
                };
                return;
            }
            const invoice = await taskBuyPlan.perform();
            console.log(invoice);
            if (!invoice) {
                return;
            }
            const widget = new window.cp.CloudPayments();
            if (!widget) {
                return;
            }
            const data = {};
            if (shouldRecurrent.value) {
                const startDate = new Date();
                startDate.setMonth(startDate.getMonth() + 1);
                startDate.setDate(startDate.getDate() - 1);
                data.CloudPayments = {
                    recurrent: {
                        interval: 'Month',
                        period: currentTab.value?.months,
                        startDate,
                    },
                };
            }
            try {
                const response = await widget.pay('charge', {
                    accountId: invoice.userId,
                    amount: Number(invoice.amount),
                    currency: 'RUB',
                    data,
                    description: paymentModal.value.subtitle,
                    email: invoice.email,
                    publicId: process.env.CP_PUBLIC_ID,
                    invoiceId: invoice.id,
                    skin: 'modern',
                });
                const { data: userInfo } = await duck.users.getCurrentUser();
                user.info = userInfo;
                // ReasonCode
                // email
                // transactionId
                console.log(response);
            }
            catch (e) {
                console.log(e);
            }
        }
        return {
            activeTab,
            css,
            currentTab,
            currentPromo,
            comment,
            modal,
            openFeaturesModal,
            openPaymentModal,
            tabs,
            taskBuyPlan,
            shouldRecurrent,
        };
    },
});
